export default function OffClick($rootScope, $parse) {
    'ngInject';

    const listeners = {};
    let id = 0;
    let ignoreBodyClick;

                document.addEventListener('click', offClickEventHandler, true);

                function targetInFilter(target, elms) {
                    if (!target || !elms) {
                        return false;
                    }
                    const elmsLen = elms.length;
                    for (let i = 0; i < elmsLen; ++i) {
                        if (elms[i].contains(target)) {
                            return true;
                        }
                    }
                    return false;
                }

                function offClickEventHandler(event) {
                    const target = event.target || event.srcElement;
                    angular.forEach(listeners, function(listener) {
                        if (!(listener.elm.contains(target)
                            || targetInFilter(target, listener.offClickFilter)
                            || (ignoreBodyClick && target === document.body))) {

                            $rootScope.$evalAsync(function() {
                                listener.cb(listener.scope, {$event: event});
                            });
                        }
                    });
                }

                return {
                    restrict: 'A',
                    compile: function($element, attr) {
                        ignoreBodyClick = Boolean(attr.offClickIgnoreBodyClick);
                        const fn = $parse(attr.offClick);
                        return function(scope, element) {
                            const elmId = id++;
                            let offClickFilter;
                            let removeWatcher;

                            offClickFilter = document.querySelectorAll(scope.$eval(attr.offClickFilter));

                            if (attr.offClickIf) {
                                removeWatcher = $rootScope.$watch(
                                    function() {
                                        return $parse(attr.offClickIf)(scope);
                                    }, function(newVal) {
                                        if (newVal) {
                                            on();
                                        } else if (!newVal) {
                                            off();
                                        }
                                    }
                                );
                            } else {
                                on();
                            }

                            attr.$observe(
                                'offClickFilter', function(value) {
                                    offClickFilter = document.querySelectorAll(scope.$eval(value));
                                }
                            );

                            scope.$on(
                                '$destroy', function() {
                                    off();
                                    if (removeWatcher) {
                                        removeWatcher();
                                    }
                                }
                            );

                            /**
                             * Enable offclick handler
                             */
                            function on() {
                                listeners[elmId] = {
                                    elm: element[0],
                                    cb: fn,
                                    scope,
                                    offClickFilter,
                                };
                            }

                            /**
                             * Disable offclick handler
                             */
                            function off() {
                                delete listeners[elmId];
                            }
                        };
                    },
                };
}



// WEBPACK FOOTER //
// ./src/app/directives/offClick.directive.js